/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Tokenaccesscountmax3Inputs */

const de__field_tokenaccesscountmax3 = /** @type {(inputs: _Field_Tokenaccesscountmax3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Anzahl der Token-Anmeldungen für Schüler:innen`)
};

/**

* @param {_Field_Tokenaccesscountmax3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_tokenaccesscountmax3 = /** @type {((inputs?: _Field_Tokenaccesscountmax3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Tokenaccesscountmax3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_tokenaccesscountmax3(inputs)
});
export { _field_tokenaccesscountmax3 as "_field_tokenAccessCountMax" }